<script>
    import {formatPrice} from '@/utils';

    export default {
        functional: true,
        render(createElement, { props, children }) {
            return createElement('span',
                props.symbol.predictionClose > 0 ? formatPrice(props.symbol.predictionOpen) +'-'+ formatPrice(props.symbol.predictionClose) :'-');
        }
    };
</script>